<script setup>
import { onMounted, reactive, watch, ref, computed } from "vue";
import Choices from "choices.js";

defineOptions({
    inheritAttrs: false,
});

const input = ref(null);
let choices = reactive({});

const props = defineProps({
    modelValue: null,
    options: Array,
    required: {
        type: Boolean,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    errors: {
        type: Object,
        default: {},
    },
});

defineEmits(["update:modelValue"]);

const toggleDisabled = computed(() => {
    return props.disabled ? choices.enable() : choices.disable();
});

onMounted(() => {
    choices = new Choices(input.value, {
        searchEnabled: true,
        allowHTML: false,
        shouldSort: false,
    });

    setChoices();
});

watch(
    () => props.modelValue,
    (newValue) => {
        choices.setChoiceByValue(newValue);
    }
);

watch(
    () => props.options,
    () => {
        setChoices();
    }
);

watch(
    () => props.disabled,
    (newValue) => {
        newValue ? choices.disable() : choices.enable();
    }
);

const setChoices = () => {
    // choices.clearChoices()
    choices
        .setChoices(props.options, "id", "name", false)
        .setChoiceByValue(props.modelValue);
};
</script>

<template>
    <div class="form-group mb-1">
        <label class="form-control ms-0" :for="$attrs.id" v-if="$attrs.label">{{
            $attrs.label
            }}</label>

        <select ref="input" class="form-control" :id="$attrs.id"
            @change="$emit('update:modelValue', $event.target.value)">
            <option value="">{{ $t("messages.select_option") }}</option>
        </select>

        <small class="text-danger" style="font-size: 0.7rem; top: 40px" v-if="errors.$error">
            {{ errors.$errors[0].$message }}
        </small>
    </div>
    <small v-if="errors.$error" class="text-danger" style="font-size: 0.8rem; top: 40px">
        {{ errors.$errors[0].$message }}
    </small>
</template>

<style>
.choices {
    margin-bottom: 0 !important;
}
</style>
